<template>
    <div>
        <v-progress-linear class="w-100" style="min-height: 2px" indeterminate color="primary" v-if="loading || data == null"></v-progress-linear>
        <div v-if="data && data.data.merchant_data">
            <my-form ref="form">
                <div class="row">
                    <div class="col-md-3">
                        <div class="mb-2">Individual informations:</div>
                        <v-text-field outlined :rules="[validationRules.required]" :label="$t('First name')" v-model="data.data.merchant_data.individual.firstName"></v-text-field>
                        <v-text-field outlined :rules="[validationRules.required]" :label="$t('Last name')" v-model="data.data.merchant_data.individual.lastName"></v-text-field>
                        <v-text-field outlined :rules="[validationRules.required, validationRules.email]" :label="$t('Email')" v-model="data.data.merchant_data.individual.email" type="email"></v-text-field>
                        <v-menu
                                ref="menu1"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                        outlined
                                        name="date_of_birth"
                                        v-model="data.data.merchant_data.individual.dateOfBirth"
                                        label="Date of birth"
                                        v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker class="w-100" v-model="data.data.merchant_data.individual.dateOfBirth" no-title></v-date-picker>
                        </v-menu>
                        <v-text-field outlined :label="$t('Phone')" v-model="data.data.merchant_data.individual.phone"></v-text-field>
                    </div>
                    <div class="col-md-3">
                        <div class="mb-2">Your address info</div>
                        <v-text-field outlined :rules="[validationRules.required]" :label="$t('Street address')" v-model="data.data.merchant_data.individual.address.streetAddress"></v-text-field>
                        <v-text-field outlined :rules="[validationRules.required]" :label="$t('Locality')" v-model="data.data.merchant_data.individual.address.locality"></v-text-field>
                        <v-text-field outlined :rules="[validationRules.required]" :label="$t('Region')" v-model="data.data.merchant_data.individual.address.region"></v-text-field>
                        <v-text-field outlined :rules="[validationRules.required]" :label="$t('Postal code')" v-model="data.data.merchant_data.individual.address.postalCode"></v-text-field>
                    </div>
                    <div class="col-md-3">
                        <div class="mb-2">Funding information</div>
                        <v-text-field outlined :rules="[validationRules.required]" :label="$t('Email')" v-model="data.data.merchant_data.funding.email"></v-text-field>
                        <v-text-field outlined :rules="[validationRules.required]" :label="$t('Account number')" v-model="data.data.merchant_data.funding.accountNumber"></v-text-field>
                        <v-text-field outlined :rules="[validationRules.required]" :label="$t('Routing number')" v-model="data.data.merchant_data.funding.routingNumber"></v-text-field>
                    </div>
                </div>
            </my-form>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import {braintreeMerchant} from "../../api/websites";

    export default {
        data:() => {
            return{
                loading:false,
                data:null,
                resolve: null,
                reject: null
            }
        },
        mounted(){
            Vue.prototype.$merchant = this;
        },
        methods:{
            editAdd(data){
                return new Promise((resolve, reject) => {
                    this.resolve = resolve;
                    this.reject = reject;
                    if(!data.id){
                        this.setNew();
                    }else{
                        this.data = data;
                    }
                })
            },
            copy(from_obj, to){
                this.$set(to, 'streetAddress', from_obj.streetAddress);
                this.$set(to, 'locality', from_obj.locality);
                this.$set(to, 'region', from_obj.region);
                this.$set(to, 'postalCode', from_obj.postalCode);
            },
            save(){
                return new Promise((resolve, reject) => {
                    braintreeMerchant(this.data.data.merchant_data).then(res => {
                        this.$store.commit('app/ADD_MESSAGE', {text: this.$t('Succesfully created merchant.')})
                    }).catch(e => {
                        this.$store.commit('app/ADD_MESSAGE', {text: this.$t('There was error during creating'), type:'error'})
                        if(e.response.data && e.response.data.errors){
                            var errors = e.response.data.errors;
                            for(var i in errors){
                                this.$store.commit('app/ADD_MESSAGE', {text: i+' : '+errors[i][0], type:'error'})
                            }
                        }
                    })
                })
            },
            setNew(){
                this.data = {
                    controller: 'website_braintree',
                    data: {
                        merchant_data:{
                            individual: {
                                address:{}
                            },
                            business: {
                                address:{}
                            },
                            funding:{

                            }
                        }
                    },
                    name: 'Website braintree merchant',
                }
            },
            validate(){
                return this.$refs.form.my_validate();
            }
        }
    }
</script>
